// authUtils.js

import { PERSONA_INCLUSIONS } from "../constants/permissions";

/**
 * Inclusion (allow-list) permission check.
 *
 * Returns true only when at least one of the user's personas explicitly
 * grants the required permission via PERSONA_INCLUSIONS.
 *
 * Default-deny semantics:
 *   - Empty / missing personas           -> false
 *   - Persona not in PERSONA_INCLUSIONS  -> false
 *   - Persona present but doesn't list   -> false
 *     the requested permission
 *
 * @param {string[]} personas
 * @param {string} requiredPermission
 * @returns {boolean}
 */
export const hasPermission = (personas = [], requiredPermission) => {
  if (!requiredPermission || !Array.isArray(personas) || personas.length === 0) {
    return false;
  }

  for (const persona of personas) {
    const allowed = PERSONA_INCLUSIONS[persona];
    if (Array.isArray(allowed) && allowed.includes(requiredPermission)) {
      return true;
    }
  }

  return false;
};
